import axios from "axios";
import { API_URL } from "../../const";
export const fetchAllCallback = (fetchData: JSON) => {
  const data = {
    CallBackToken: fetchData,
  };

  const url = `${API_URL}GetCallBack`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
/** *************** END LIST CALL BACK  DETAILS ***************** */

export const exportAllCallback = (fetchData: JSON) => {
  const data = {
    ExportCallBackPDfToken: fetchData,
  };

  const url = `${API_URL}Excel/export.php`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};

/** *************** END EXPORT CALL BACK  DETAILS ***************** */
export const ComonExportPage = (fetchData: JSON) => {
  const data = {
    CreateRequestReportToken: fetchData,
  };

  const url = `${API_URL}CreateRequestReport`;
  return axios.post(url, data, {
    headers: { "Content-type": "application/json" },
  });
};
